<template>
  <!-- Modals -->
  <CompaniesModal :company="header.company" />
  <CookiesModal v-bind="header.cookie" />
  <SearchModal title="What are you looking for?" placeholder="enter keywords" btn-text="Search" href="/" />
  <!--   Modals end -->
  <div class="header-wrapper">
<!--    <HeaderAlert content="<p>Lorem ipsum dolor sit</p>" />-->
    <!--  Burger-->
    <div class="offcanvas offcanvas-top"
      tabindex="-1" id="offcanvasBurger"
      aria-labelledby="offcanvasTopLabel"
    >
      <div class="offcanvas-body container">
        <div class="accordion-burger" id="accordionBurger">
          <div class="accordion-item" v-for="(nav, index) in header.navigation">
            <div class="accordion-header d-flex" :id="`heading${nav.id}`">
              <Link :href="nav.url">{{ nav.title }}</Link>
              <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#collapse-${index}`"
                  aria-expanded="true"
                  :aria-controls="`#collapse-${index}`"
                  @click="toggleAccordion(index)"
                  :class="{'border-0': isOpen[index]}"
              >
            </button>
            </div>
            <div
                :id="`#collapse-${index}`"
                class="accordion-collapse collapse"
                :aria-labelledby="`heading${nav.id}`"
                data-bs-parent="#accordionBurger"
                :class="{'show': isOpen[index]}"
            >
              <div class="accordion-body">
                <ul>
                  <li v-for="item in nav.children" :key="item.id">
                    <Link :href="item.link" class="d-block">{{ item.title }}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex buttons">
          <ButtonCircle hyperlink :href="header.info.serviceCenter.link" class="me-3">
            <FaqIcon />
          </ButtonCircle>
          <ButtonCircle>
            <button type="button" class="d-flex justify-content-center btn-nulled px-0" data-bs-toggle="modal" data-bs-target="#searchModal">
              <SearchIcon />
            </button>
          </ButtonCircle>
        </div>
      </div>
    </div>
    <!--  Burger end-->
    <header class="header d-flex align-items-center">
      <section class="container header-main">
        <div class="row">
          <div class="col-9 col-lg-5 d-flex align-items-center nav-logo-container">
            <div class="d-flex align-items-center ms-md-3">
              <Link href="/">
                <img :src="header.company.logo.imgLink" class="website-logo" :alt="header.company.logo.altText" width="150" height="86">
              </Link>
              <DividerIcon class="mt-3 mx-2 mx-sm-3 mx-md-4 mx-lg-4" />
              <div class="d-flex align-items-center header-logo-list">
                <div class="sublogo-container">
                  <p v-if="header.company.title && header.company.sublogoImg.imgLink">{{ header.company.title }}</p>
                  <p v-else>See all company brands:</p>
                  <button type="button" class="btn-nulled d-flex flex-column align-items-center p-0" data-bs-toggle="modal" data-bs-target="#companiesModal">
                    <img :src="[header.company.sublogoImg.imgLink || altLogo]" :alt="[header.company.sublogoImg.altText || 'sublogo-image']" class="header-sublogo d-block" width="125" height="30">
                    <TriangleMini class="mt-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3 col-lg-7 d-flex justify-content-end align-items-center nav-info-container">
            <div class="d-none d-lg-flex flex-column align-items-end nav-contact-info">
              <div class="info-nav d-flex">
                <div class="info-nav__buttons d-flex">
                  <ButtonCircle hyperlink :href="header.info.contactUs.link" class="mx-3 icon-effect">
                    <contact-us-icon />
                  </ButtonCircle>
                  <ButtonCircle hyperlink :href="header.info.serviceCenter.link" class="me-3 icon-effect">
                    <FaqIcon />
                  </ButtonCircle>
                  <ButtonCircle data-bs-toggle="modal" data-bs-target="#searchModal" class="icon-effect-stroke">
                    <SearchIcon />
                  </ButtonCircle>
                </div>
                <ButtonRed class="ms-3" :text="header.info.phone.text" :phone="header.info.phone.phoneNumber" />
              </div>
              <nav class="d-flex" >
                <!--                v-on-click-outside="() => closeNavigation(index, true)"-->
                <!--                :class="{'show': showNav[index]}"-->
                <div
                    v-for="(item, index) in header.navigation"
                    :key="item.id"
                    ref="droplistRef"
                    class="nav-dropdown position-relative"
                >
                  <div class="d-flex align-items-center">
                    <Link :href="item.url" class="btn-nulled underline-effect p-0 fw-bold menu-item d-inline-block me-1 text-nowrap" :class="{'nav-active': item.isActive }">{{ item.title }}</Link>
                    <ArrowDownIcon />
                  </div>
                  <div class="nav-dropdown__droplist position-absolute d-none">
                    <div class="nav-dropdown__droplist-border d-flex p-1">
                      <div class="nav-dropdown__droplist-border__triangle" ref="triangleRef"></div>
                      <div class="d-flex nav-dropdown__droplist-wrapper">
                        <ul
                            class="w-100 nav-dropdown__droplist-column me-3"
                            v-for="column in chunkArray(item.children, 7)"
                            :key="column.id"
                        >
                          <li
                              class="nav-dropdown__droplist-item"
                              v-for="listItem in column"
                              :key="listItem.id"
                          >
                            <Link :href="listItem.link">{{listItem.title}}</Link>
                          </li>
                        </ul>
                      </div>
                      <div class="w-100 nav-dropdown__droplist-column-img">
                        <img :src="item.img.link" :alt="item.img.altText" class="h-100 w-100 fit-cover" width="260" height="350">
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
            <div class="d-flex d-lg-none justify-content-end align-items-center nav-mobile-controls">
              <ButtonCircle hyperlink :href="header.info.contactUs.link" class="me-3">
                <span class="phone-icon">
                  <contact-us-icon />
                </span>
              </ButtonCircle>
              <ButtonCircle :phone="header.info.phone.phoneNumber" class="me-3">
                <span class="phone-icon">
                  <PhoneIcon />
                </span>
              </ButtonCircle>
              <button
                  @click="handleBurger"
                  class="btn-nulled position-relative offcanvas-trigger"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBurger"
                  aria-controls="offcanvasTop"
              >
                <span class="menu header-burger d-block" :class="{open: show}">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </header>
  </div>
  
</template>

<script setup>
import DividerIcon from "@/assets/icons/divider-icon";
import PhoneIcon from "@/assets/icons/phone-icon";
import SearchIcon from "@/assets/icons/search-icon";
import ContactUsIcon from "@/assets/icons/contact-us-icon";
import FaqIcon from "@/assets/icons/faq-icon";
import ArrowDownIcon from "@/assets/icons/arrow-down-icon";
import ButtonCircle from "@/components/common/ButtonCircle";
import ButtonRed from "@/components/common/ButtonRed";
import TriangleMini from "@/assets/icons/triangle-mini";
import {chunkArray, handleListeners, getHeaderAlertHeight} from '@/utils/utils'
import altLogo from '@/assets/images/alt-logo.png';
import {ref, onMounted, onUnmounted, defineAsyncComponent} from "vue";
import Link from "@/components/common/Link";

const CompaniesModal = defineAsyncComponent(() => import("@/components/common/modals/CompaniesModal"));
const SearchModal = defineAsyncComponent(() => import("@/components/common/modals/SearchModal"));
const CookiesModal = defineAsyncComponent(() => import("@/components/cookie-policy/cookies-modal"));

const props = defineProps({
  alert: HTMLElement,
  header: {
    company: {
      title: String,
      logo: {
        imgLink: String,
        altText: String
      },
      sublogoImg: {
        imgLink: String,
        altText: String
      },
      sublogoContent: {
        title: String,
        description: String,
        logos: Array
      }
    },
    info: {
      serviceCenter: {
        link: String
      },
      contactUs: {
        link: String
      },
      phone: {
        text: String,
        number: String
      }
    },
    navigation: Array
  },
  mailingModal: {
    logo: {
      alt: String,
      link: String,
    },
    title: String,
    description: String,
    btnText: String
  },
})
const isOpen = ref({})
const show = ref(false)
const searchValue = ref('')
const alertHeight = ref('')
const droplistRef = ref(null)
const searchModalRef = ref(null)
const triangleRef = ref(null)
// const showNav = ref({})

initStateObjects()

onMounted(() => {
  setDroplistPosition();
  clearInputOnModalClose();
  setAlertHeight()
  handleListeners(['resize'], setAlertHeight)
  getHeaderAlertHeight()
})

onUnmounted(() => {
  handleListeners(['resize'], setAlertHeight, true)
})

function initStateObjects(){
  for(const itemId in props.header.navigation) {
    Object.assign(isOpen.value, {[itemId]: false})
    // Object.assign(showNav.value, {[itemId]: false})
  }
}

function closeNavigation(index, closeAll){
  for(const item in showNav.value) {
    if(closeAll) showNav.value[index] = false
    else (+item !== index) && (showNav.value[item] = false)
  }
}

function handleNavClick(index){
  closeNavigation(index)
  showNav.value[index] = !showNav.value[index]
}

function handleBurger() {
  const header = document.querySelector('.vue-header');
  const headerAlert = document.querySelector('.header-alert');

  show.value = !show.value;
  alertHeight.value = getHeaderAlertHeight();

  if (show.value && header && headerAlert) {
    header.style.top = 0;
    headerAlert.style.position = 'fixed';
  }

  if (!show.value && header && headerAlert) {
    header.style.top = 0;
    headerAlert.style.position = 'static';
  }
}

function setDroplistPosition(){
  const elementArray = droplistRef.value;
  const triangleArray = triangleRef.value;

  for(let index = 0; index < elementArray.length; index++) {
    if(elementArray.length >= 5) {
      if(index === elementArray.length - 1 || index === elementArray.length - 2 || index === elementArray.length - 3) {
        elementArray[index].querySelector('.nav-dropdown__droplist').style.cssText = 'right: 0;'
        triangleArray[index].style.left = '94%'
        continue;
      }
      elementArray[index].querySelector('.nav-dropdown__droplist').style.cssText = 'left: 50%; transform: translateX(-50%);'
    } else {
      elementArray[index].querySelector('.nav-dropdown__droplist').style.cssText = 'right: 0;'
      triangleArray[index].style.left = '94%'
    }
  }
}

function clearInputOnModalClose(){
  const myModalEl = searchModalRef.value;
  const clearValue = () => searchValue.value = '';

  myModalEl && myModalEl.addEventListener('hidden.bs.modal', function (event) {
    clearValue()
  })
}

function toggleAccordion(index) {
  isOpen.value[index] = !isOpen.value[index];
}

function setAlertHeight(){
  alertHeight.value = getHeaderAlertHeight();
}

function handleScroll() {
  let header = document.querySelector("header");

  if (window.pageYOffset > 100) {
    header.classList.add("small");
  } else {
    header.classList.remove("small");
  }
}

window.addEventListener("scroll", handleScroll);
</script>
